import React, { Component } from 'react';
import {
    Label,
    Row,
    Col,
} from 'reactstrap';
import './Notes.css';

class ListNotes extends Component {
    constructor(props) {
        super(props);
        this.createdTS = parseInt(String(props.row.created).substr(5, 2)) + '/' + parseInt(String(props.row.created).substr(8, 2)) + '/' + String(props.row.created).substr(2, 2);
        this.updatedTS = parseInt(String(props.row.timestamp).substr(5, 2)) + '/' + parseInt(String(props.row.timestamp).substr(8, 2)) + '/' + String(props.row.timestamp).substr(2, 2);
    }

    displayType = (validation, item) => {
        switch (validation) {
            case "checkbox":
                return (item === 'true') ? "Yes" : "No"
            default:
                return item;
        }
    }

    parsePhone = (val) => {
        if (val.length !== 10 || isNaN(val)) return val;
        return `(${val.substring(0,3)}) ${val.substring(3,6)}-${val.substring(6,10)}`;
    }

    render() {
        const dt = this.displayType;
        return (
            <Row key={this.props.row.linkedID} className="notesFormTypeRow pointer" onClick={() => this.props.handleEditSwap(this.props.row.linkedID)}>
                <Col sm={9} className="notesFormTypeComments text-left"><>
                    {/* {this.props.row.type === 'Contact' && <>
                        <Row className="notesFormCommentRow">
                            <Col md={5} className="border-bottom pb-1 pt-1">
                                {this.props.row.children.findIndex(child => child.type === 'Contact Name') > -1 ? this.props.row.children[this.props.row.children.findIndex(child => child.type === 'Contact Name')].comment : ''}
                            </Col>
                            <Col md={7} className="border-bottom pb-1 pt-1">
                                {this.props.row.children.findIndex(child => child.type === 'Title') > -1 ? this.props.row.children[this.props.row.children.findIndex(child => child.type === 'Title')].comment : ''}
                            </Col>
                        </Row>
                        <Row className="notesFormCommentRow">
                            <Col md={5} className="border-bottom pb-1 pt-1">
                                {this.props.row.children.findIndex(child => child.type === 'Phone Number') > -1 && <div>{this.parsePhone(this.props.row.children[this.props.row.children.findIndex(child => child.type === 'Phone Number')].comment)}</div>}
                                {this.props.row.children.findIndex(child => child.type === 'Phone Number (Office)') > -1 && <div>{this.parsePhone(this.props.row.children[this.props.row.children.findIndex(child => child.type === 'Phone Number (Office)')].comment)} <span class="commentTag">Office</span></div>}
                                {this.props.row.children.findIndex(child => child.type === 'Phone Number (Mobile)') > -1 && <div>{this.parsePhone(this.props.row.children[this.props.row.children.findIndex(child => child.type === 'Phone Number (Mobile)')].comment)} <span class="commentTag">Mobile</span></div>}
                                {this.props.row.children.findIndex(child => child.type === 'Phone Number (Personal)') > -1 && <div>{this.parsePhone(this.props.row.children[this.props.row.children.findIndex(child => child.type === 'Phone Number (Personal)')].comment)} <span class="commentTag">Personal</span></div>}
                                {this.props.row.children.findIndex(child => child.type === 'Phone Number (Home)') > -1 && <div>{this.parsePhone(this.props.row.children[this.props.row.children.findIndex(child => child.type === 'Phone Number (Home)')].comment)} <span class="commentTag">Home</span></div>}
                            </Col>
                            <Col md={7} className="border-bottom pb-1 pt-1">
                                {this.props.row.children.findIndex(child => child.type === 'Email Address') > -1 && <div>{this.parsePhone(this.props.row.children[this.props.row.children.findIndex(child => child.type === 'Email Address')].comment)}</div>}
                                {this.props.row.children.findIndex(child => child.type === 'Email Address (Office)') > -1 && <div>{this.parsePhone(this.props.row.children[this.props.row.children.findIndex(child => child.type === 'Email Address (Office)')].comment)} <span class="commentTag">Office</span></div>}
                                {this.props.row.children.findIndex(child => child.type === 'Email Address (Personal)') > -1 && <div>{this.parsePhone(this.props.row.children[this.props.row.children.findIndex(child => child.type === 'Email Address (Personal)')].comment)} <span class="commentTag">Personal</span></div>}
                            </Col>
                        </Row>
                    </>} */}
                    {this.props.row.children
                    // .filter(child => ((child.type !== 'Contact Name' && child.type !== 'Title' && child.type.indexOf('Email Address') === -1 && child.type.indexOf('Phone Number') === -1)))
                        .map((comment, index) =>
                        (<Row key={comment.ID+'_'+index} className="notesFormCommentRow">
                            <Col sm={5} className={(index < this.props.row.children.length - 1 ? "border-bottom pb-1 " : "") + "pt-1"}>
                                <Label>{comment.type}</Label>
                            </Col>
                            <Col sm={7} className={(index < this.props.row.children.length - 1 ? "border-bottom pb-1 " : "") + "pt-1"}>
                                {
                                    String(comment.comment).split("\n").map(function (item, idx) {
                                        const displayType = dt(comment.validation, item);
                                        return (
                                            <div key={item+'_'+idx}>
                                                {displayType}
                                                <br />
                                            </div>
                                        )
                                    })
                                }
                            </Col>
                        </Row>))}
                </>
                </Col>
                <Col sm={3} className="notesFormTypeControls text-right">
                    {/* <Button
                        key={'edit_' + this.props.row.linkedID}
                        color="primary"
                        value={this.props.row.linkedID}
                        onClick={this.props.handleEditSwap}
                        title="Edit"
                    ><FontAwesomeIcon icon={this.props.loading && this.props.editID === this.props.row.linkedID ? faSpinner : faEdit} /></Button> */}
                    {/* <Button
                        key={'delete_' + this.props.row.linkedID}
                        color="danger"
                        value={this.props.row.linkedID}
                        onClick={this.props.handleDelete}
                        title="Delete"
                    ><FontAwesomeIcon icon={this.props.loading && this.props.editID === this.props.row.linkedID ? faSpinner : faTrashAlt} /></Button> */}
                    <div className="noteCreatedTimestamp" >
                        {this.createdTS}
                    </div>
                    {this.createdTS !== this.updatedTS ?
                        <div className="noteUpdatedTimestamp" title={String(this.props.row.timestamp).substr(11, 2) + ':' + String(this.props.row.timestamp).substr(14, 2) + ' by ' + this.props.row.user.firstName + ' ' + this.props.row.user.lastName}>
                            {this.updatedTS}
                        </div> : <></>}
                    <div className="noteCreatedTimestamp" title={String(this.props.row.timestamp).substr(11, 2) + ':' + String(this.props.row.timestamp).substr(14, 2) + ' by ' + this.props.row.user.firstName + ' ' + this.props.row.user.lastName}>
                        {this.props.row.user.firstName + ' ' + this.props.row.user.lastName}
                    </div>
                </Col>
            </Row>
        )
    }
}

export default ListNotes;
